import FileTable from './FileTable';
import './FileTable.scss';

export default FileTable;
